import { render, staticRenderFns } from "./SuppressedList.vue?vue&type=template&id=a3fc3424&"
import script from "./SuppressedList.vue?vue&type=script&lang=js&"
export * from "./SuppressedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3fc3424')) {
      api.createRecord('a3fc3424', component.options)
    } else {
      api.reload('a3fc3424', component.options)
    }
    module.hot.accept("./SuppressedList.vue?vue&type=template&id=a3fc3424&", function () {
      api.rerender('a3fc3424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/vistas/emails/SuppressedList.vue"
export default component.exports